import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';

export interface DropReason {
  _id: string;
  value: string;
  description?: string;
  active: boolean;
  order?: number;
}

const fetchDropReasons = async (): Promise<DropReason[]> => {
  const response = await api.get('lookups/LeadDropReason');
  return response.data.data;
};

export const useLeadDropReasons = () => {
  return useQuery<DropReason[], Error>({
    queryKey: ['lookups', 'LeadDropReason'],
    queryFn: fetchDropReasons,
  });
};
